<button
  [type]="type"
  [class]="buttonClass"
  [disabled]="disabled"
  (click)="onClick()"
>
  <span>{{ label }}</span>
</button>
